import { Button, Col, Divider, Row, Typography, theme } from 'antd'
import { DateRange, DrawerBottom } from 'components'
import { useCallback, useEffect, useState } from 'react'
import { useScreen, useTranslations } from 'hooks'

import { Body } from './ProductRangeSelectFixed.styles'
import PropTypes from 'prop-types'

const { Title, Text } = Typography

const ProductRangeSelectFixed = (props) => {
  const {
    disabled,
    periodInDays,
    range,
    handleChangeRange,
    pricePerDayDisplay,
    pricePerPeriodDisplay,
    computedDayLabel,
    formattedDateRange,
    handleBuyProduct,
    disabledDates
  } = props

  const { t } = useTranslations()
  const token = theme.useToken().token
  const { xs } = useScreen()

  const [isOpened, setIsOpened] = useState(false)

  const titleLevel = isOpened ? 3 : 5
  const showExtraInHeader = !isOpened

  const handleToggle = (event) => {
    event.stopPropagation()
    setIsOpened((prevValue) => !prevValue)
  }
  const handleReserve = async (event) => {
    await handleBuyProduct(event)
    setIsOpened(false)
  }
  const checkClicking = useCallback(
    (event) => {
      if (event?.target?.id !== 'product-range-select') {
        isOpened && setIsOpened(false)
      }
    },
    [isOpened]
  )

  useEffect(() => {
    document.addEventListener('click', checkClicking)

    return () => window.removeEventListener('click', checkClicking)
  }, [isOpened, checkClicking])

  return (
    <DrawerBottom
      isOpened={isOpened}
      xs={xs}
      theme={token}
      onClick={handleToggle}
      id="product-range-select">
      <Row>
        <Col className="mr-auto flex-1">
          <Row>
            <Col span={24} className="flex align-baseline">
              <Title level={titleLevel}>{pricePerDayDisplay}</Title>
              <Text type="secondary">{`/${t('day')}`}</Text>
            </Col>
            <Col span={24} className="min-content-width">
              <Text type="secondary">{formattedDateRange}</Text>
            </Col>
          </Row>
        </Col>
        {showExtraInHeader && (
          <>
            <Col className="flex flex-col align-end">
              <Text type="secondary">{t('Total')}</Text>
              <Title level={5}>{pricePerPeriodDisplay}</Title>
            </Col>
            <Col>
              <Divider type="vertical" className="full-height mx-16" />
            </Col>
            <Col className="flex align-center">
              <Button type="primary" disabled={disabled}>
                {t('Reserve')}
              </Button>
            </Col>
          </>
        )}
      </Row>

      <Body>
        <Row>
          <Col span={24}>
            <DateRange
              disabledDates={disabledDates}
              showHeader={false}
              onChange={handleChangeRange}
              range={range}
              periodInDays={periodInDays}
            />
          </Col>
          <Col span={24}>
            <Divider />
          </Col>
          <Col span={24}>
            <Row gutter={16} className="justify-between">
              <Col className="flex gap-4">
                <Typography.Text>{t('Period')}:</Typography.Text>
              </Col>
              <Col>{t(computedDayLabel)}</Col>
            </Row>
          </Col>
          <Col span={24}>
            <Divider />
          </Col>
          <Col span={24} className="flex justify-between mb-24">
            <Typography.Title level={5}>{t('Total')}</Typography.Title>
            <Typography.Title level={5}>
              {pricePerPeriodDisplay}
            </Typography.Title>
          </Col>
          <Col span={24}>
            <Button
              disabled={disabled}
              block
              size="large"
              id="buy-product"
              type="primary"
              key="buy-product"
              onClick={handleReserve}>
              {t('Reserve')}
            </Button>
          </Col>
        </Row>
      </Body>
    </DrawerBottom>
  )
}

ProductRangeSelectFixed.propTypes = {
  periodInDays: PropTypes.number,
  range: PropTypes.object,
  handleChangeRange: PropTypes.func,
  pricePerDayDisplay: PropTypes.string,
  pricePerPeriodDisplay: PropTypes.string,
  computedDayLabel: PropTypes.string,
  formattedDateRange: PropTypes.string,
  handleBuyProduct: PropTypes.func,
  disabled: PropTypes.bool,
  productId: PropTypes.string,
  disabledDates: PropTypes.array
}

export default ProductRangeSelectFixed
